
const useStyles = () => {

    return {
        mainContainer: {
            padding: 1, 
            width: '450px', 
            height: '100vh' ,
        },
        containerTtitle: {
            display:'flex',
            alignItems:'center',
            justifyContent: 'space-between',
        },
        containerButon:{
            marginTop:1,
            display:'flex',
            justifyContent: 'end',
        },
        activities: {
            display:'flex', 
            flexDirection:'column', 
            gap:1, 
            padding:1,
            height:'90%',
            overflow: 'auto'
        }
    }
}

export { useStyles }